module.exports = __webpack_public_path__ + "static/media/wheat-soft.b79b3b23.png";